<h1>Edit User - {{ user.firstName }}</h1>

<form [formGroup]="editUserForm" (ngSubmit)="onSubmit()">
    <div class="validation-summary-errors" *ngIf="editUserForm.touched && editUserForm.invalid">
        <ul>
            <li *ngIf="editUserForm.touched && editUserForm.controls['firstName'].invalid">First Name can't be empty.</li>
            <li *ngIf="editUserForm.touched && editUserForm.controls['lastName'].invalid">Last Name can't be empty.</li>
            <li *ngIf="editUserForm.touched && editUserForm.controls['email'].errors?.required">Email can't be empty.</li>
            <li *ngIf="editUserForm.touched && editUserForm.controls['email'].errors?.email">Email is invalid.</li>
            <li *ngIf="editUserForm.touched && editUserForm.controls['branchId'].errors?.required">Branch can't be empty.</li>
            <li *ngIf="editUserForm.touched && editUserForm.errors?.exists">User already exists.</li>
        </ul>
    </div>
    <div class="form-group">
        <label for="firstName">First Name</label>
        <input
            id="firstName"
            class="form-control w-md-25"
            autofocus="autofocus"
            type="text"
            formControlName="firstName"
            [ngClass]="{ 'input-validation-error': editUserForm.touched && editUserForm.controls['firstName'].invalid }"
        />
    </div>
    <div class="form-group">
        <label for="lastName">Last Name</label>
        <input
            id="lastName"
            class="form-control w-md-25"
            autofocus="autofocus"
            type="text"
            formControlName="lastName"
            [ngClass]="{ 'input-validation-error': editUserForm.touched && editUserForm.controls['lastName'].invalid }"
        />
    </div>
    <div class="form-group">
        <label for="email">Email</label>
        <input
            id="email"
            class="form-control w-md-25"
            autofocus="autofocus"
            type="text"
            formControlName="email"
            [ngClass]="{ 'input-validation-error': editUserForm.touched && editUserForm.controls['email'].invalid }"
        />
    </div>
    <div class="form-group" [hidden]="!isBranchRequired">
        <label for="branchId">Branch</label>
        <ng-select
            [items]="branches"
            bindLabel="branchName"
            bindValue="branchId"
            formControlName="branchId"
            class="w-md-25"
            [ngClass]="{ 'input-validation-error': editUserForm.touched && editUserForm.controls['branchId'].invalid }"
        >
        </ng-select>
    </div>

    <h6>Roles</h6>
    <div class="form-group">
        <div class="custom-control custom-radio">
            <input type="radio" id="customRadio1" class="custom-control-input" formControlName="roles" value="branch" (change)="roleStateSub($event)" />
            <label class="custom-control-label" for="customRadio1">Branch</label>
        </div>
        <div class="custom-control custom-radio">
            <input type="radio" id="customRadio2" class="custom-control-input" formControlName="roles" value="admin" (change)="roleStateSub($event)" />
            <label class="custom-control-label" for="customRadio2">Admin</label>
        </div>
    </div>
    <div class="form-group">
        <div class="custom-control custom-switch">
            <input type="checkbox" id="isEnabled" formControlName="isEnabled" class="custom-control-input" />
            <label for="isEnabled" class="custom-control-label cursor-pointer">is Enabled</label>
        </div>
    </div>

    <div class="form-group">
        <button class="btn btn-primary btn-sm" type="submit" [disabled]="formBusy">Save</button>
        <button class="btn btn-danger btn-sm ml-2" type="button" (click)="confirmDelete(user)">delete</button>
        <button class="btn btn-secondary btn-sm ml-2" type="button" (click)="location.back()">Cancel</button>
    </div>
</form>
